import { useContext } from "react";
import { CancelActionContext } from "./CancelActionContext";

function usePrepareCancel() {
  const { setElementId, setShowModal } = useContext(CancelActionContext);
  return (id: any) => {
    setElementId(id);
    setShowModal(true);
  };
}

export default usePrepareCancel;
